import { ColInfo, WorkSheet, utils } from "sheetjs-style-v2"

export const getSheetRange = (worksheet: WorkSheet) => {
  const { e: end, s: start } = utils.decode_range(worksheet["!ref"] ?? "A1:A1")

  return {
    columnStartIndex: start.c,
    columnEndIndex: end.c,
    rowStartIndex: start.r,
    rowEndIndex: end.r,
  }
}

/**
 * Set the width of all columns of the given worksheet to fit the content of the cells.
 */
export const autoFitColumnsWidth = (worksheet: WorkSheet) => {
  const { columnStartIndex, columnEndIndex, rowEndIndex, rowStartIndex } = getSheetRange(worksheet)

  const objectMaxLength: ColInfo[] = []

  for (let colIndex = columnStartIndex; colIndex <= columnEndIndex; colIndex++) {
    let maxCellLength = 0

    for (let rowIndex = rowStartIndex; rowIndex <= rowEndIndex; rowIndex++) {
      const cellAddress = utils.encode_cell({ c: colIndex, r: rowIndex })
      const cell = worksheet[cellAddress]

      // cell may not exist if row / span are merged
      if (!cell) continue

      const cellLength = String(cell.v).length + 1
      if (cellLength > maxCellLength) maxCellLength = cellLength
    }

    objectMaxLength.push({ width: maxCellLength })
  }

  worksheet["!cols"] = objectMaxLength
}

export const boldenHeaderRow = (worksheet: WorkSheet) => {
  const { columnStartIndex, columnEndIndex, rowStartIndex } = getSheetRange(worksheet)

  for (let colIndex = columnStartIndex; colIndex <= columnEndIndex; colIndex++) {
    const cellAddress = utils.encode_cell({ c: colIndex, r: rowStartIndex })
    worksheet[cellAddress].s = {
      ...worksheet[cellAddress].s,
      font: { ...worksheet[cellAddress].s?.font, bold: true },
    }
  }
}

export const alignCellsVertically = (worksheet: WorkSheet, align: "bottom" | "center" | "top") => {
  const { columnStartIndex, columnEndIndex, rowStartIndex, rowEndIndex } = getSheetRange(worksheet)

  for (let colIndex = columnStartIndex; colIndex <= columnEndIndex; colIndex++) {
    for (let rowIndex = rowStartIndex; rowIndex <= rowEndIndex; rowIndex++) {
      const cellAddress = utils.encode_cell({ c: colIndex, r: rowIndex })
      const cell = worksheet[cellAddress]

      // cell may not exist if row / span are merged
      if (!cell) continue

      worksheet[cellAddress].s = {
        ...worksheet[cellAddress].s,
        alignment: { ...worksheet[cellAddress].s?.alignment, vertical: align },
      }
    }
  }
}
